module.exports = __webpack_public_path__ + "static/media/11_4.3e2fd63d.jpg";